import { render } from "./CashbookTable.vue?vue&type=template&id=38647aa2&scoped=true&ts=true"
import script from "./CashbookTable.vue?vue&type=script&lang=ts"
export * from "./CashbookTable.vue?vue&type=script&lang=ts"

import "./CashbookTable.vue?vue&type=style&index=0&id=38647aa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38647aa2"]])

export default __exports__